export const UrlParamKeys = {
  AuthenticationTypeOverride: 'auth',
  AuthSetting: 'authSetting',
  ClosePopupWhenDone: 'closePopupWhenDone',
  DeviceType: ':device',
  EditDataAlert: ':editDataAlert',
  ResumeDataAlert: ':resumeDataAlert',
  Embedded: 'embedded',
  FromFailureEmail: ':fromFailureEmail',
  FromSuccessEmail: ':fromSuccessEmail',
  RedirectSource: 'redirect_source',
  IsFromSaml: ':isFromSaml',
  Order: 'order',
  PublishedDataSources: 'publishedDataSources',
  RemoteAgentWorkflowId: 'remoteAgentWorkflowId',
  SiteLuid: 'siteLuid',
  SiteUrlName: 'siteUrlName',
  SyncAvailable: 'syncAvailable',
  SyncRunning: 'syncRunning',
  PublishedWithLQS : 'publishedWithLQS',
  PublishedDataSourcesWithLQS : 'publishedDataSourcesWithLQS',
  OriginalView : ':original_view',
  SuppressResumeMetricBanner: 'suppressResumeMetricBanner',
};
